import { Icon, Tooltip } from '@shopify/polaris';
import { ClipboardIcon } from '@shopify/polaris-icons';
import parse from 'html-react-parser';
import { memo } from 'react';
import { QuickCopyTextStyled } from './styled';
interface IProps {
  text: string;
  onClick?: () => void;
}

const QuickCopyText = (props: IProps) => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <QuickCopyTextStyled onClick={handleClick}>
      <div className="content">{parse(props.text)}</div>
      <div className="icon">
        <Tooltip content="Insert">
          <Icon source={ClipboardIcon} />
        </Tooltip>
      </div>
    </QuickCopyTextStyled>
  );
};

export default memo(QuickCopyText);
